import { useQuery } from "@tanstack/react-query"
import { supabase } from "@/integrations/supabase/client"
import { useAuth } from "./useAuth"
import { errorHandler } from "@/utils/errorHandler"
import { logger } from "@/utils/logger"

export const useAvailableUsers = () => {
  const { profile } = useAuth()
  
  return useQuery({
    queryKey: ["available-users", profile?.role],
    queryFn: async () => {
      try {
        logger.info("Carregando usuários disponíveis", "useAvailableUsers", {
          userRole: profile?.role
        })

        let query = supabase
          .from("profiles")
          .select("id, full_name, role, apartment_number")
          .eq("is_active", true)
          .neq("id", profile?.id)
          .eq("condominium_id", profile?.condominium_id)

        // Filtragem baseada em regras de permissão
        if (profile?.role === 'sindico') {
          // Síndicos podem ver todos os usuários do condomínio
          // Não é necessário filtrar por papel
        } 
        else if (profile?.role === 'porteiro') {
          // Porteiros podem ver síndicos e moradores
          query = query.in("role", ["sindico", "morador"])
        }
        else if (profile?.role === 'morador') {
          // Moradores podem ver síndicos e porteiros
          query = query.in("role", ["sindico", "porteiro"])
        }
        // Para outros papéis (administração, etc)
        else {
          query = query.in("role", ["sindico", "porteiro", "morador"])
        }

        const { data, error } = await query

        if (error) {
          logger.error("Erro ao buscar usuários disponíveis", "useAvailableUsers", error)
          errorHandler.handleError({
            code: 'USER_LOAD_ERROR',
            message: error.message,
            details: error
          })
          throw error
        }

        logger.info("Usuários disponíveis carregados", "useAvailableUsers", { 
          count: data?.length || 0,
          userRole: profile?.role
        })

        return data || []
      } catch (error) {
        logger.error("Erro na query de usuários disponíveis", "useAvailableUsers", error)
        throw error
      }
    },
    enabled: !!profile?.id
  })
}